import { multiServerUpload, MultiServerUploadOptions } from "blossom-client-sdk/actions/multi-server";
import { Chunk } from "./blob";

type UploadOptions = MultiServerUploadOptions<string, Chunk> & {
  parallel?: number;
};

export async function uploadChunks(servers: string[], chunks: Chunk[], opts?: UploadOptions) {
  const parallel = opts?.parallel ?? 5;
  let batch: Promise<any>[] = [];

  for (const chunk of chunks) {
    if (opts?.signal?.aborted) break;
    batch.push(multiServerUpload(servers, chunk, opts));

    // wait for batch
    if (batch.length >= parallel) {
      await Promise.allSettled(batch);
      batch = [];
    }
  }

  // wait for complete
  if (batch.length > 0) await Promise.allSettled(batch);
}
